import { DocStatus } from "@types";
import { docStatusDictionary } from "src/utils/documents";

type DocumentStatusIconProps = {
  reserveSpace?: boolean;
  size?: number;
  status?: DocStatus;
  testId?: string;
};

export const DocumentStatusIcon = ({
  reserveSpace = false,
  size = 8,
  status,
  testId,
}: DocumentStatusIconProps) => {
  if (!status && !reserveSpace) {
    return null;
  }

  return (
    <span
      aria-label={status ? `Document status: ${status.toLowerCase()}` : undefined}
      data-status={status}
      data-testid={testId}
      style={{
        alignItems: "center",
        display: "inline-flex",
        flexShrink: 0,
        height: size,
        justifyContent: "center",
        minWidth: size,
        width: size,
      }}
    >
      {status ? (
        <span
          style={{
            backgroundColor: docStatusDictionary[status].borderColor,
            borderRadius: "999px",
            display: "block",
            height: size,
            width: size,
          }}
        />
      ) : null}
    </span>
  );
};
